import React from 'react';
import { ProductCard } from '../components/ProductCard';
import { HeroImage } from '../components/HeroImage';
import { Users, Briefcase, Sparkles, Plane } from 'lucide-react';

export const Products = () => {
  const products = [
    {
      name: 'LinkIQ',
      description: 'AI-powered link intelligence and SEO visibility platform. Track, analyze, and optimize your link strategy with advanced machine learning algorithms. Built for marketers and agencies who need comprehensive link management at scale.',
      audience: 'Digital marketers, SEO agencies, content strategists',
      url: 'https://linkiq.pro/',
      logo: 'https://customer-assets.emergentagent.com/job_optiflo-corporate/artifacts/h46cl5nj_linkiq-logo-light.png'
    },
    {
      name: 'Opti Flo Connect',
      description: 'Universal integration and control plane for modern applications. Seamlessly connect GoHighLevel with hundreds of third-party services. Purpose-built for agencies managing multiple client accounts and complex automation workflows.',
      audience: 'Agencies, automation specialists, system integrators',
      url: 'https://connect.optiflo.app/',
      logo: 'https://customer-assets.emergentagent.com/job_optiflo-corporate/artifacts/x6xqhklg_Opti%20Flo%20Connect%20Logo%20P3d%20White.png'
    },
    {
      name: 'HighReach Apps',
      description: 'Smart Websites and Apps built for local and small businesses. Create professional, modern web presence and mobile applications tailored to your business needs.',
      audience: 'Local businesses, small businesses, entrepreneurs',
      url: 'https://highreachapps.com',
      logo: '/highreach-logo.png'
    },
    {
      name: 'Voyae',
      description: 'Social-first travel discovery and booking platform. Connect travelers with authentic experiences through real user-generated content. Built on modern commerce infrastructure with social discovery at its core.',
      audience: 'Travelers, content creators, experience providers',
      url: 'https://govoyae.com/',
      logo: 'https://customer-assets.emergentagent.com/job_optiflo-corporate/artifacts/bg1cco3y_Voyae%20Finale%20Logo%27s%20%281%29.png'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <HeroImage
        title="OUR PRODUCTS"
        subtitle="Independent platforms with a shared backbone. Each product solves specific problems while integrating seamlessly with the ecosystem."
      />

      {/* Products List - White Background */}
      <section className="py-20 md:py-32 bg-white">
        <div className="container mx-auto px-5 md:px-10">

        <div className="space-y-12 max-w-5xl mx-auto">
          {products.map((product) => (
            <div
              key={product.name}
              className="bg-black border border-gray-800 rounded-xl p-8 md:p-12 hover:border-[#f43cde] transition-all"
            >
              <div className="flex flex-col md:flex-row gap-8">
                <div className="flex-shrink-0">
                  {product.logo ? (
                    <img src={product.logo} alt={product.name} className="h-16 w-auto" />
                  ) : (
                    <div>{product.icon}</div>
                  )}
                </div>
                
                <div className="flex-grow">
                  <h2 className="heading-3 mb-4">{product.name}</h2>
                  <p className="body-medium text-on-dark mb-4">
                    {product.description}
                  </p>
                  
                  <div className="mb-6">
                    <p className="caption text-[#f43cde] mb-2">PRIMARY AUDIENCE</p>
                    <p className="body-small text-on-dark text-muted-dark">{product.audience}</p>
                  </div>
                  
                  <a
                    href={product.url}
                    className="btn-primary inline-block"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit {product.name}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        </div>
      </section>

      {/* CTA Section - Black Background */}
      <section className="py-20 md:py-32 bg-black">
        <div className="container mx-auto px-5 md:px-10 text-center">
          <p className="body-large text-on-dark mb-8 max-w-2xl mx-auto">
            Interested in partnerships or platform integrations?
          </p>
          <a href="/partnerships" className="btn-secondary">
            Learn About Partnerships
          </a>
        </div>
      </section>
    </div>
  );
};